import { faSoapNote } from "@awesome.me/kit-0572d5a008/icons/kit/custom";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useFormContext } from "react-hook-form";

import { TEMPLATE_TYPES } from "../../../constants";
import TemplateFormButton from "../common/TemplateFormButton";

const ChooseTemplateType = ({
  control,
  disableButton,
  handleTemplateTypeChange,
}) => {
  const { getValues } = useFormContext(control);
  const formData = getValues();

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-1">
        Format
      </label>
      <div className="flex gap-2">
        <TemplateFormButton
          icon={faSoapNote}
          title="SOAP"
          description="This will generate a note in separate Subjective, Objective, Assessment, and Plan sections."
          isSelected={formData.templateType === TEMPLATE_TYPES.SOAP}
          name="templateType"
          value={TEMPLATE_TYPES.SOAP}
          checked={formData.templateType === TEMPLATE_TYPES.SOAP}
          onChange={handleTemplateTypeChange}
          disableButton={disableButton}
          dataTestId="template-soap-button"
        />
        <TemplateFormButton
          icon={faFile}
          title="Freeform"
          description="This will generate a note in a single text box, formatted however you specify in your template and preferences."
          isSelected={formData.templateType === TEMPLATE_TYPES.CUSTOM}
          name="templateType"
          value={TEMPLATE_TYPES.CUSTOM}
          checked={formData.templateType === TEMPLATE_TYPES.CUSTOM}
          onChange={handleTemplateTypeChange}
          disableButton={disableButton}
          dataTestId="template-freeform-button"
        />
      </div>
    </div>
  );
};

export default ChooseTemplateType;
